import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LOGO_CIVISOFT, LOGO_GEO5 } from "../constants";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function LoginPage({ onLogin }) {
  const { t } = useTranslation();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [erreur, setErreur]     = useState("");
  const [showPwd, setShowPwd]   = useState(false);

  const GV = {
    vert:"#2D7A2D", vertClair:"#00A651", vertLight:"#E8F5E9",
    dark:"#1A1A1A", gris:"#F5F5F5", grisMid:"#757575",
    border:"#E0E0E0", blanc:"#FFFFFF", rouge:"#DC2626",
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { setErreur(t("login.erreur_identifiants")); return; }
    setLoading(true);
    setErreur("");
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        if (data.detail === "ACCES_EXPIRE") {
          onLogin(null, "EXPIRE");
        } else {
          setErreur(data.detail || t("login.erreur_identifiants"));
        }
        return;
      }
      localStorage.setItem("geo5_token", data.access_token);
      localStorage.setItem("geo5_user", JSON.stringify(data.user));
      onLogin(data.user);
    } catch {
      setErreur(t("login.erreur_serveur"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"linear-gradient(160deg,#f0fdf4 0%,#dcfce7 50%,#bbf7d0 100%)", display:"flex", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ width:"100%", maxWidth:440 }}>

        {/* Logos */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:32 }}>
          {LOGO_CIVISOFT && <img src={LOGO_CIVISOFT} alt="CiviSoft" style={{ height:48, objectFit:"contain" }}/>}
          {LOGO_GEO5     && <img src={LOGO_GEO5}     alt="GEO5"     style={{ height:36, objectFit:"contain" }}/>}
        </div>

        {/* Carte login */}
        <div style={{ background:GV.blanc, borderRadius:20, boxShadow:"0 8px 40px rgba(0,0,0,0.12)", overflow:"hidden" }}>

          {/* Header */}
          <div style={{ background:`linear-gradient(135deg,${GV.vert},${GV.vertClair})`, padding:"28px 32px" }}>
            <div style={{ fontSize:22, fontWeight:900, color:GV.blanc, marginBottom:4 }}>{t("app.titre")}</div>
            <div style={{ fontSize:13, color:"rgba(255,255,255,0.85)" }}>{t("login.soustitre")}</div>
          </div>

          {/* Formulaire */}
          <form onSubmit={handleLogin} style={{ padding:"32px" }}>

            <div style={{ marginBottom:20 }}>
              <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:8 }}>{t("login.email")}</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder={t("login.email_placeholder")} autoFocus
                style={{ width:"100%", padding:"12px 14px", fontSize:14, border:`1.5px solid ${email ? GV.vert : GV.border}`, borderRadius:10, outline:"none", boxSizing:"border-box", transition:"border 0.2s" }}
              />
            </div>

            <div style={{ marginBottom:24 }}>
              <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:8 }}>{t("login.mot_de_passe")}</label>
              <div style={{ position:"relative" }}>
                <input
                  type={showPwd ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)}
                  placeholder={t("login.mdp_placeholder")}
                  style={{ width:"100%", padding:"12px 44px 12px 14px", fontSize:14, border:`1.5px solid ${password ? GV.vert : GV.border}`, borderRadius:10, outline:"none", boxSizing:"border-box", transition:"border 0.2s" }}
                />
                <button type="button" onClick={() => setShowPwd(!showPwd)}
                  style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:18, color:GV.grisMid }}>
                  {showPwd ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            {erreur && (
              <div style={{ background:"#FEF2F2", border:"1.5px solid #DC2626", borderRadius:8, padding:"10px 14px", fontSize:13, color:GV.rouge, marginBottom:20 }}>
                ⚠️ {erreur}
              </div>
            )}

            <button type="submit" disabled={loading}
              style={{ width:"100%", padding:"14px", background:loading ? GV.border : `linear-gradient(135deg,${GV.vert},${GV.vertClair})`, border:"none", borderRadius:10, fontSize:15, fontWeight:800, color:GV.blanc, cursor:loading ? "not-allowed" : "pointer", boxShadow:loading ? "none" : `0 4px 16px ${GV.vert}40`, transition:"all 0.2s" }}>
              {loading ? t("login.connexion_en_cours") : t("login.connecter") + " →"}
            </button>

            <div style={{ marginTop:20, textAlign:"center", fontSize:12, color:GV.grisMid }}>
              CIVISOFT — <strong style={{ color:GV.vert }}>civisoft-fr.com</strong>
            </div>
          </form>
        </div>

        <div style={{ textAlign:"center", marginTop:20, fontSize:11, color:"#6b7280" }}>
          GEO5 Expert Advisor © 2025 CIVISOFT
        </div>
      </div>
    </div>
  );
}
